module.exports = __webpack_public_path__ + "img/meeting.d592801b.svg";